export function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
export const iterator = getSymbolIterator();
export const $$iterator = iterator;
//# sourceMappingURL=iterator.js.map